import React from 'react';
import { Menu } from 'new/elements/Menu';
import DataSamplesProcessor from 'js/lib/DataSamplesProcessor';
import { useRecipeBuilderData } from 'new/elements/NexsetSchemaViewer/useRecipeBuilderData';
import { Nexset } from 'new/entities/Nexset';

interface MenuDownloadProps {
  anchorEl: Element;
  open: boolean;
  onClose: () => void;
  nexset: Nexset;
}

export const MenuDownload = (props: MenuDownloadProps) => {
  const { nexset } = props;
  const { schema, samples, nestedSamples } = useRecipeBuilderData(nexset);

  const onDownload = (format: 'csv' | 'json') => () => {
    DataSamplesProcessor.downloadSamples(
      { input: schema },
      { input: { nested: nestedSamples, flat: samples } },
      format,
      nexset ? `nexset-${nexset.id}-` : '',
    );
  };

  const items = [
    {
      label: 'CSV Download',
      onClick: onDownload('csv'),
    },
    {
      label: 'JSON Download',
      onClick: onDownload('json'),
    },
  ];
  return <Menu items={items} {...props} />;
};
